<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Process Tasks Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Test Process: Sort Tasks" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <test-process-card v-if="test_process_id" :test_process="test_process" />
    <template v-if="test_task_collection">
      <h2>Tasks</h2>
      <sortable-list
        :list="test_task_collection.models"
        :keyField="'id'"
        :labelField="'name'"
        :groupBy="['name']"
        @onOrderChange="storeOrder"
      />
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SortableList from "@/components/shared/SortableList";
import TestProcessCard from "@/components/lab/testprocess/TestProcessCard";
import TestTaskModel from "@/models/lab/TestTaskModel";
import { getModel, getCollection } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TestProcessSort",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    SortableList,
    TestProcessCard,
  },
  data() {
    return {
      loading: true,
      test_process_id: this.$route.params.id || null,
      test_process: null,
      test_task_collection: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/test-processes",
            title: "Test process list",
          },
          {
            icon: "fa-eye",
            linkto: `/test-processes/${this.test_process_id}`,
            title: "View test processes",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      const filters = [
        {
          logic: "filterEquals",
          field: "test_process_id",
          value: this.test_process_id,
        },
      ];
      const sort = [
        {
          logic: "sortAddAsc",
          field: "order",
        },
      ];

      this.test_process = await getModel({
        model_type: "test_process",
        id: this.test_process_id,
        message: this.$bvToast,
      });
      this.test_task_collection = await getCollection({
        collection_type: "test_task",
        filters,
        sort,
        message: this.$bvToast,
      });

      this.loading = false;
    },
    storeOrder(list) {
      list.forEach((list_item, index) => {
        let model = new TestTaskModel(list_item);

        model.set("order", index);
        model.save();
      });
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
